import { CONFIG } from '../config';

export function getFirestoreDocUrl(collection: string, docId?: string) {
  const projectId = CONFIG.FIREBASE.PROJECT_ID;
  const base = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/${collection}`;
  const url = docId ? `${base}/${docId}` : base;
  
  console.log('[PROD_DEBUG][getFirestoreDocUrl]', {
    projectId,
    collection,
    docId,
    constructedUrl: url
  });
  
  return url;
}